export default __webpack_public_path__ + "static/media/icon-arrow-button-right.551943ad.svg";